import { render, staticRenderFns } from "./TipoVehiculoForm.vue?vue&type=template&id=6f00d78d"
import script from "./TipoVehiculoForm.vue?vue&type=script&lang=js"
export * from "./TipoVehiculoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports